import { render, staticRenderFns } from "./OrganizationAndVehicle.vue?vue&type=template&id=268945de&scoped=true"
import script from "./OrganizationAndVehicle.vue?vue&type=script&lang=js"
export * from "./OrganizationAndVehicle.vue?vue&type=script&lang=js"
import style0 from "./OrganizationAndVehicle.vue?vue&type=style&index=0&id=268945de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268945de",
  null
  
)

export default component.exports